import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
    {
        id: "po-05-h5v0-01",
        name: "PO 01 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 51, y: 233, width: 273, height: 173, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 414, width: 273, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 233, width: 273, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 332, y: 414, width: 273, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 706, y: 234, width: 554, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-02",
        name: "PO 02 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 213, width: 322, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 415, width: 322, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 330, y: 213, width: 322, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 415, width: 322, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 660, y: 213, width: 651, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-03",
        name: "PO 03 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 187, width: 325, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 415, width: 325, height: 219, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 187, width: 645, height: 447, rotation: 0, imageRotation: 0 },
            { id: "4", x: 986, y: 187, width: 325, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 986, y: 415, width: 325, height: 219, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-04",
        name: "PO 04 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 49, y: 167, width: 529, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 510, width: 171, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 228, y: 510, width: 171, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 406, y: 510, width: 171, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 675, y: 223, width: 529, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-05",
        name: "PO 05 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 193, width: 626, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 80, width: 392, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 332, width: 392, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 743, y: 584, width: 192, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 942, y: 584, width: 192, height: 119, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-06",
        name: "PO 06 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 190, y: 138, width: 261, height: 165, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 309, width: 261, height: 166, rotation: 0, imageRotation: 0 },
            { id: "3", x: 321, y: 309, width: 260, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 190, y: 481, width: 261, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 675, y: 223, width: 529, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-07",
        name: "PO 07 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 145, y: 77, width: 337, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 145, y: 289, width: 337, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 145, y: 501, width: 337, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 695, y: 77, width: 488, height: 311, rotation: 0, imageRotation: 0 },
            { id: "5", x: 695, y: 395, width: 488, height: 311, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-08",
        name: "PO 08 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 39, y: 219, width: 547, height: 346, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 79, width: 392, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 332, width: 192, height: 119, rotation: 0, imageRotation: 0 },
            { id: "4", x: 942, y: 332, width: 192, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 743, y: 459, width: 392, height: 245, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-09",
        name: "PO 09 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 73, y: 219, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 415, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 367, y: 219, width: 578, height: 384, rotation: 0, imageRotation: 0 },          
            { id: "4", x: 953, y: 219, width: 285, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 953, y: 415, width: 285, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-10",
        name: "PO 10 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
        size: [1311, 820],
        style: {},
        slots: [     
            { id: "1", x: 73, y: 120, width: 226, height: 139, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 267, width: 226, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 414, width: 226, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 73, y: 561, width: 226, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 307, y: 120, width: 930, height: 580, rotation: 0, imageRotation: 0 },
        ],
    }
];